var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfWorthBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250.558,
    height: 201.71,
    viewBox: "0 0 250.558 201.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M301.138,1788.447a43.561,43.561,0,0,1,39.626,25.506,43.566,43.566,0,0,1,83.213,18.082c0,51.513-83.213,106.989-83.213,106.989s-83.214-55.476-83.214-106.989A43.588,43.588,0,0,1,301.138,1788.447Z",
    transform: "translate(-215.484 -1788.447)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M265.464,1954.935l-25.052-36.462a13.132,13.132,0,0,1,10.666-11.658l38.044,35.763a26.473,26.473,0,0,1,8.34,19.286v28.293H256.149V1988.7a26.048,26.048,0,0,0-6.352-17.046l-29.331-33.889a20.427,20.427,0,0,1-4.979-13.7l1.248-76.746a7.1,7.1,0,0,1,7.093-6.98h3.536a7.1,7.1,0,0,1,7.1,7.1v54.172",
    transform: "translate(-215.484 -1788.447)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M416.063,1954.935l25.052-36.462a13.132,13.132,0,0,0-10.666-11.658L392.4,1942.578a26.472,26.472,0,0,0-8.339,19.286v28.293h41.312V1988.7a26.048,26.048,0,0,1,6.352-17.046l29.331-33.889a20.427,20.427,0,0,0,4.979-13.7l-1.248-76.746a7.1,7.1,0,0,0-7.093-6.98h-3.536a7.1,7.1,0,0,0-7.1,7.1v54.172",
    transform: "translate(-215.484 -1788.447)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfWorthBg);
export default __webpack_public_path__ + "static/media/self-worth-bg.aa31301a8cbd122c45f6fb43654ea2e0.svg";
export { ForwardRef as ReactComponent };